"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAlgoliaProductToProduct = void 0;
const location_1 = require("./location");
function mapToPrice(price) {
    if (!price) {
        return undefined;
    }
    const { grossAmount, currencyCode } = price;
    return {
        gross: {
            amount: `${grossAmount}`,
            currencyCode,
        },
    };
}
const mapAlgoliaProductToProduct = (product, queryId) => {
    const locations = product.locations?.map(location => ({
        name: location.city,
        lat: location.position.lat,
        long: location.position.lon,
    }));
    return {
        locations,
        queryId,
        productId: product.productId,
        productType: product.productType,
        manufacturerSku: product.manufacturerSku,
        title: product.title,
        url: product.url,
        trackingName: product.trackingName,
        trackingPath: product.trackingPath,
        price: mapToPrice(product.price),
        originalPrice: product.originalPrice ? mapToPrice(product.originalPrice) : undefined,
        classifications: product.classifications,
        sellOption: product.sellOption,
        services: product.productInformation?.services,
        images: product.images,
        rating: product.rating,
        inPreview: product.inPreview,
        isTestProduct: product.isTestProduct,
        participants: product.participants,
        discountBadge: product.discountBadge,
        closestLocation: (0, location_1.getClosestLocation)(product),
        // eslint-disable-next-line no-underscore-dangle
        highlightedTitle: product._highlightResult?.title?.value,
        hasPriceRange: product.hasPriceRange,
    };
};
exports.mapAlgoliaProductToProduct = mapAlgoliaProductToProduct;
//# sourceMappingURL=mapAlgoliaProductToProduct.js.map